
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">Thông tin người giúp việc - tài xế</h3>
      </div>
      <div class="box-body">
        <div class="row pull-right">
          <div class="col-md-12">
            <button
              class="btn btn-info btn-sm extra-tools pull-right"
              @click="onOpenAddRelatedResidentInput"
            >
              <i class="glyphicon glyphicon-plus"></i>
              Add
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive no-padding">
            <b-table :items="related_residents_items" :fields="related_residents_fields" class="mt-3" outlined>
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="actions" slot-scope="row">
                <div class="btn-group">
                  <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px;height: 80px;">
                    <li><button
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenEditRelatedResidentInput(row)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button></li>
                      <li><button
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenDeleteRelatedResident(row)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button></li>
                  </ul>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="box-footer">
      </div>
    </div>
    <!-- Modal Relative Input -->
    <div class="modal fade" :ref="`modal-customer-related-resident-input`">
      <div class="modal-dialog modal-lg">
        <RelatedResidentsInputView
          :id="related_resident_data.id"
          @related_resident-add="onAddRelatedResident"
          @related_resident-save="onSaveRelatedResident"
        />
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-customer-related-resident-delete`">
      <div class="modal-dialog">
        <Confirm
          :id="related_resident_data.id"
          @confirm="onDeleteRelatedResident"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import RelatedResidentsInputView from './RelatedResidentsInputView'
import Confirm from "@/components/Confirm.vue"
import ResidentContractEnum from "@/enum/residentContractEnum";
// import utils from '@/lib/utils'

export default {
  name: "RelatedResidentsView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      related_resident_data: {
        id: 0
      },
      related_residents_fields: [
        { key: 'nonumber', label: 'common.nonumber', sortable: true, class: 'text-center' },
        { key: 'full_name', label: 'customer.relatives.full_name', sortable: true, class: 'text-center' },
        { key: 'gender', label: 'customer.relatives.gender', sortable: true, class: 'text-center' },
        { key: 'identification_number', label: 'customer.relatives.identification_number', sortable: true, class: 'text-center' },
        { key: 'passport', label: 'customer.relatives.passport', sortable: true, class: 'text-center' },
        { key: 'phone_number', label: 'customer.relatives.phone_number', sortable: true, class: 'text-center' },
        { key: 'resident_contract', label: 'customer.relatives.resident_contract', sortable: true, class: 'text-center' },
        { key: 'resident_type', label: 'customer.relatives.resident_type', sortable: true, class: 'text-center' },
        { key: "actions", label: "common.action", sortable: true }
      ],
      related_residents_items: [],
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.getRelatedResidentList()
      } else {
        // pass
      }
    },
    RELATIVES_LIST: function() {
      let related_residents_items = []
      let nonumber = 0
      this.RELATIVES_LIST.forEach( (relative, i) => {
        if (relative.resident_type == 1) {return}
        nonumber += 1
        let id = relative.id
        let full_name = relative.full_name
        let gender = this.getGender(relative.gender)
        let phone_number = relative.phone_number
        let passport = relative.passport
        let identification_number = relative.identification_number
        let resident_contract = this.getResidentContractName(relative.resident_contract)
        let resident_type = this.getRelatedResidentTypeName(relative.resident_type)
        let item = {
          id: id,
          nonumber: nonumber,
          full_name: full_name,
          gender: gender,
          phone_number: phone_number,
          passport: passport,
          identification_number: identification_number,
          resident_contract: resident_contract,
          resident_type: resident_type
        }
        related_residents_items.push(item)
      })
      this.related_residents_items = related_residents_items
      this.$emit('related_residents_items', this.related_residents_items)
    }
  },
  computed: {
    ...mapGetters([
      "RELATIVES_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "ADD_RELATIVE",
      "UPDATE_RELATIVE",
      "DELETE_RELATIVE",
      "GET_RELATIVE_LIST",
      "GET_CARDS_LIST"
    ]),
    getGender: function (gender) {
      if(gender==1){
        return this.$t(`customer.gender_type[0]`)   
      }
      if(gender==2){
        return this.$t(`customer.gender_type[1]`)   
      }
      if(gender==3){
        return this.$t(`customer.gender_type[2]`)
      }
    },
    getResidentContractName: function (type) {
      if (type == ResidentContractEnum.FULLTIME) {
        return this.$t("customer.contract.fulltime")
      } else if (type == ResidentContractEnum.PARTTIME) {
        return this.$t("customer.contract.parttime")
      }
      return ""
    },
    getRelatedResidentTypeName: function(type) {
      if (type == 2) {
        return this.$t('customer.related_resident_types.housekeeper')
      } else if (type == 3) {
        return this.$t('customer.related_resident_types.driver')
      }
      return ""
    },
    getCardsList: function(data){
      if (this.id == 0){ return }
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_CARDS_LIST(payload)
    },
    onToggleModalInput: function(action="show") {
      $(this.$refs[`modal-customer-related-resident-input`]).modal(action)
    },
    onToggleDeleteConfirm: function(action="show") {
      $(this.$refs[`modal-customer-related-resident-delete`]).modal(action)
    },
    getRelatedResidentList: function(data){
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_RELATIVE_LIST(payload)
    },
    onAddRelatedResident: function(saveRelative) {
      saveRelative.user = this.id
      const payload = {
        data: saveRelative
      }
      this.ADD_RELATIVE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getRelatedResidentList()
          this.getCardsList()
        }.bind(this)
      )
    },
    onSaveRelatedResident: function(id, saveRelative) {
      saveRelative.user = this.id
      const payload = {
        id: id,
        data: saveRelative
      }
      this.UPDATE_RELATIVE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getRelatedResidentList()
          this.getCardsList()
        }.bind(this)
      )
    },
    onOpenAddRelatedResidentInput: function() {
      this.related_resident_data.id = 0
      this.onToggleModalInput()
    },
    onOpenEditRelatedResidentInput: function(row) {
      this.related_resident_data.id = row.item.id
      this.onToggleModalInput()
    },
    onOpenDeleteRelatedResident: function(row) {
      this.related_resident_data.id = row.item.id
      this.onToggleDeleteConfirm()
    },
    onDeleteRelatedResident: function(id) {
      const payload = {
        id: id
      }
      this.DELETE_RELATIVE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide")
          this.getRelatedResidentList()
          this.getCardsList()
        }.bind(this)
      )
    },
  },
  mounted() {
  },
  components: {
    RelatedResidentsInputView,
    Confirm
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Customer/RelatedResidentsView.vue